exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-class {\n  background-color: #ddd;\n  border: 2px solid #fff; }\n  .asset-class div {\n    padding: 6px 0px 6px 15px;\n    margin: 0px; }\n  @media (min-width: 320px) and (max-width: 480px) {\n    .asset-class > div {\n      padding: 5px 0px 5px 15px; }\n    .asset-class {\n      border: 1px solid #fff; } }\n  @media (min-width: 481px) and (max-width: 761px) {\n    .asset-class > div {\n      padding: 5px 0px 5px 15px; }\n    .asset-class {\n      border: 2px solid #fff; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/PortfolioDashboard/navigationPages/Component page/LiveAsset/section1/treemapHolder.scss
// module id = 888
// module chunks = 0